export default {
    invoiceByCustomerList: [],
    invoiceByCustomerData: {items: [], _links: {}, _meta: {}}
}
